import { httpRequest } from "@services/http";

/** Derived server-side from is_draft and the window (MPN-2264). */
export type BannerStatus = "Draft" | "Scheduled" | "Live" | "Expired";

export interface Banner {
  uuid: string;
  message: string;
  /** "" when the banner has no link. */
  link_text: string;
  link_url: string;
  /** UTC ISO; null only for drafts. */
  starts_at: string | null;
  /** null = runs until turned off. */
  ends_at: string | null;
  status: BannerStatus;
  /** "First Last", falling back to the email. */
  created_by: string;
  create_date: string;
}

export const bannersUrl = () => `${import.meta.env.VITE_API_PLATFORM_SERVICE_URL}api/v1/banners/`;

export class CommandListBanners {
  async run(): Promise<Banner[]> {
    try {
      return await httpRequest<Banner[]>(bannersUrl(), { method: "GET" });
    } catch (error) {
      console.error("Error fetching banners:", error);
      throw error;
    }
  }
}
